module.exports = __webpack_public_path__ + "static/media/t23.14b3c505.jpg";